var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerDeliveryCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker-delivery-completed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Marker-/-Completed-Delivery"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,40 C25,28.631212 30,20.2254149 30,14.7826087 C30,6.61839935 23.2842712,0 15,0 C6.71572875,0 0,6.61839935 0,14.7826087 C0,20.2254149 5,28.631212 15,40 Z",
    id: "Oval-Copy-5",
    fill: "#44D784"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#7E47D7",
    cx: 15,
    cy: 15,
    r: 11
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerDeliveryCompleted);
export default __webpack_public_path__ + "static/media/map-marker-delivery-completed.c182a2562caeb9289f4f3fc48ca2e44b.svg";
export { ForwardRef as ReactComponent };